var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortPanel',{attrs:{"id":_vm.id,"sortObject":_vm.sort},on:{"changeSort":_vm.changeSort}})}
var staticRenderFns = []

export { render, staticRenderFns }